import {ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild} from '@angular/core';
import {DataARPaymentModel} from '../../../../models/accountsReceivable/data-ar-payment.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataARClaimItemListModel} from '../../models/data-ar-claim-item-list';
import {DataARPaymentDistribsListModel} from '../../models/data-ar-payment-distribs-list.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {DataArPaymentAuditModel} from '../../models/data-ar-payment-audit.model';
import {CfgARPaymentProcessorModel} from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {CreatePaymentModel} from '../../models/create-payment.model';
import {Globals} from '../../../../globals';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {PaymentProcessorDeviceListModel} from '../../../configuration/models/payment-processor-device-list.model';
import {RectangleHealthTransactionPayload} from '../../models/rectangle-health-transaction-payload';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';

@Component({
  standalone: false,
  selector: 'app-ar-payment-refund-confirm',
  templateUrl: './ar-payment-refund-confirm.component.html',
  styleUrls: ['./ar-payment-refund-confirm.component.scss']
})
export class ArPaymentRefundConfirmComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

  OriginalPaymentID: string;
  payment: DataArPaymentAuditModel;
  paymentDistributions: DataARPaymentDistribsListModel[] = [];
  paymentProcessors: CfgARPaymentProcessorModel[] = [];
  paymentDevices: PaymentProcessorDeviceListModel[] = [];
  searchPredicate: (data: any, filter: string) => boolean;
  rectHealthPaymentPayload: RectangleHealthTransactionPayload;
  isLoading: boolean = true;
  refundAmount: number = 0;
  refundAmountNotDistributed: number = 0;
  refundFullAmount: boolean = true;
  refundMethod: string;
  refundViaCheck: boolean = false;
  paymentAmountAfterRefund: number = 0;
  refundComment: string;
  enumARProcessorID: string;
  currentWorkStationID: string;
  currentARPayment: DataARPaymentModel;
  originalPaymentProcessorID: string;
  originalPaymentDeviceID: string;

  enumPaymentTypeE: string = '00000080-1000-0000-0000-000000000003';
  enumPaymentTypeEOffline: string = '00000080-1000-0000-0000-000000000004';
  enumPaymentTypeCheck: string = '00000080-1000-0000-0000-000000000001';
  enumPaymentTypeCash: string = '00000080-1000-0000-0000-000000000002';
  enumEPayTypeCredit: string = '00000082-1000-0000-0000-000000000001';
  enumPaymentETypeCreditCard: string = '00000082-1000-0000-0000-000000000001';
  enumPaymentETypeDebitCard: string = '00000082-1000-0000-0000-000000000002';
  enumPaymentETypeCareCredit: string = '00000082-1000-0000-0000-000000000004';
  enumPaymentETypeECheck: string = '00000082-1000-0000-0000-000000000005';
  enumPaymentTransactionTypeVoidReversal: string = '00000277-1000-0000-0000-000000000002';

  enumARProcessorIDWorldPayIframe = '00000205-1000-0000-0000-000000000001';
  enumARProcessorIDRectangleHealth = '00000205-1000-0000-0000-000000000002';
  enumARProcessorIDTriPosLane3000 = '00000205-1000-0000-0000-000000000003';

  dummy: boolean = true;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ArPaymentRefundConfirmComponent>,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private changeDet: ChangeDetectorRef,
    private globals: Globals,
    private localStorageService: LocalStorageService,
  ) {
    this.searchPredicate = (searchData: DataARClaimItemListModel, filter: string) => {
      if ((!searchData.ToothName ? '' : searchData.ToothName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.ProcedureName ? '' : searchData.ProcedureName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit(): void {

    // get paymentid
    this.OriginalPaymentID = this.data.PaymentID;

    // get payment and payment distributions
    this.onLoad();
  }

  saveCurrencyField(event, inputType, id, num) {
    let blIsLessThanDistribution = true;
    let blIsLessThanRemaining = true;

    let inputValue = '';
    if (event) {
      inputValue = event.target.value;
    }
    else {
      inputValue = num.toString();
    }
    const newValue = Number(inputValue.replace(/[^0-9.-]+/g,''));

    if (inputType === 'refund') {

      if (newValue > this.payment.ApprovedPaymentAmount) {
        this.createMessage('Refund amount cannot be greater than original payment amount', 'Error');
        this.refundAmount = 0;
      }
      else {
        this.refundAmount = newValue;
      }
    }
    else if (inputType === 'dist') {
      this.paymentDistributions.forEach(a => {
        if (a.PaymetnDistributionID === id) {

          // is new amount less or equal to distribution amount
          if (newValue > a.Amount) {
            this.createMessage('Amount entered is more than amount paid', 'Error');
            blIsLessThanDistribution = false;
          }

          // using newValue, get refund distribution amount remaining
          const refundAmountDistributionRemainingForInput = this.getRefundAmountDistributionRemainingForInput(newValue, id);
          if (refundAmountDistributionRemainingForInput < 0) {
            this.createMessage('Amount entered is more than refund amount remaining', 'Error');
            blIsLessThanRemaining = false;
          }

          if (blIsLessThanRemaining && blIsLessThanDistribution) {
            a.RefundAmount = newValue;
          }
          else {
            a.RefundAmount = 0;
          }
        }
      });
    }

    // change detection
    this.changeDet.detectChanges();
    // this.changeDet.markForCheck();
  }

  getRefundAmountDistributionRemainingForInput(input: number, PaymetnDistributionID: string) {
    let refundDistributed = 0;
    this.paymentDistributions.forEach(a => {
      if (PaymetnDistributionID === a.PaymetnDistributionID) {
        refundDistributed += input;
      }
      else {
        refundDistributed += a.RefundAmount;
      }
    });

    return (this.refundAmount - refundDistributed);
  }

  setRefundAmountDistributionRemaining() {
    let refundDistributed = 0;
    this.paymentDistributions.forEach(a => {
        refundDistributed += a.RefundAmount;
    });

    this.refundAmountNotDistributed = this.refundAmount - refundDistributed;
  }

  createDataARPaymentRecord() {
    const promise = new Promise((resolve, reject) => {

      const createPayment = new CreatePaymentModel();
      createPayment.datePostPayment = new Date();
      createPayment.dateReceivedPayment = new Date();
      createPayment.Description = this.refundComment ? this.refundComment : 'Refund';
      createPayment.enumARPayementCCTypeID = // copy from original payment
      createPayment.enumARPayementETypeID = null; // copy from original payment
      createPayment.enumARPayementTypeID = this.enumPaymentTypeE;
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Patient;
      createPayment.PatientID = this.globals.currentPatientId;
      createPayment.paymentAmount = this.refundAmount;
      createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeVoidReversal;
      createPayment.LOCID = this.globals.LOCID;

      // since this is a refund, we can default to the original payment processor id, if one exists
      if (this.payment.PaymentProcessorId) {
        createPayment.PaymentProcessorID = this.payment.PaymentProcessorId;
      }

      this.arService.createDataARPaymentRecord(createPayment)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  refundClick() {

    this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
      if (newPayment) {

        // cfgARPayment record created
        // record new payment
        this.currentARPayment = newPayment;

        // if (this.enumARProcessorID === this.enumARProcessorIDTriPosLane3000) {
        //   // tripos cloud lane3000 device
        //   this.setTriPosPaymentPayload();
        //   if (this.triPosPaymentPayload) {
        //     // open payment refund confirmation dialog
        //     const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
        //       panelClass: 'dialog',
        //       data: {
        //         TransactionPayload: this.triPosPaymentPayload,
        //         PaymentID: this.currentARPayment.PaymetnID,
        //         OriginalPaymentID: this.OriginalPaymentID,
        //         Amount: this.refundAmount,
        //         Action: 2,
        //         DescriptionLong: this.refundComment,
        //         DescriptionPinPad: '',
        //         PaymentProcessorID: this.payment.PaymentProcessorId,
        //         PaymentDistributions: this.paymentDistributions,
        //         enumARProcessorID: this.enumARProcessorID
        //       }
        //     });
        //     dialogRef.afterClosed().subscribe(result => {
        //     }, err => {
        //     });
        //   }
        // }
        // else if (this.enumARProcessorID === this.enumARProcessorIDRectangleHealth) {
        //   // rectangle health device
        //   this.setRectangleHealthPaymentPayload();
        //   if (this.rectHealthPaymentPayload) {
        //     // open payment refund confirmation dialog
        //     const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
        //       panelClass: 'dialog',
        //       data: {
        //         TransactionPayload: this.rectHealthPaymentPayload,
        //         PaymentID: this.currentARPayment.PaymetnID,
        //         OriginalPaymentID: this.OriginalPaymentID,
        //         Amount: this.refundAmount,
        //         Action: 2,
        //         DescriptionLong: this.refundComment,
        //         DescriptionPinPad: '',
        //         PaymentProcessorID: this.payment.PaymentProcessorId,
        //         PaymentDistributions: this.paymentDistributions,
        //         enumARProcessorID: this.enumARProcessorID
        //       }
        //     });
        //     dialogRef.afterClosed().subscribe(result => {
        //     }, err => {
        //     });
        //   }
        // }
        // else if (this.enumARProcessorID === this.enumARProcessorIDWorldPayIframe) {
        //   // worldpay hosted payments
        //   this.setWPHostedPaymentsPaymentPayload();
        //   if (this.triPosPaymentPayload) {
        //     // using tripos
        //     // open payment refund confirmation dialog
        //     const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
        //       panelClass: 'dialog',
        //       data: {
        //         TransactionPayload: this.triPosPaymentPayload,
        //         PaymentID: this.currentARPayment.PaymetnID,
        //         OriginalPaymentID: this.OriginalPaymentID,
        //         Amount: this.refundAmount,
        //         Action: 2,
        //         DescriptionLong: this.refundComment,
        //         DescriptionPinPad: '',
        //         PaymentProcessorID: this.payment.PaymentProcessorId,
        //         PaymentDistributions: this.paymentDistributions,
        //         enumARProcessorID: this.enumARProcessorID
        //         // PayerName: this.selectedContact.FirstName + ' ' + this.selectedContact.LastName,
        //         // PatientName: this.dataPatient.dataContact.FirstName + ' ' + this.dataPatient.dataContact.LastName
        //         // EnumPaymentSourceID: this.payment.enumPaymentSourceID, *do we need this?
        //       }
        //     });
        //     dialogRef.afterClosed().subscribe(result => {
        //     }, err => {
        //     });
        //   }
        // }
        // else {
        //   // check?
        // }
      }
    }, err => {
      this.createMessage('Error creating payment record', 'Error');
    });

    // close this window after opening payment window
    this.dialogRef.close();
  }

  // setWPHostedPaymentsPaymentPayload() {

  //   // perform void transaction if payment was made on current date
  //   // perform reversal transaction if payment within 45 days of current date
  //   // perform refund transaction if payment was made more than 45 days ago

  //   try {
  //     // initialize triPos transaction payload
  //     const payload = new TriPosCloudTransactionPayload();
  //     const today = new Date();
  //     const paymentDate = new Date(this.payment.PaymentTransactionDate);
  //     today.setHours(0, 0, 0, 0);
  //     paymentDate.setHours(0, 0, 0, 0);
  //     const daysAgo = this.datediff(paymentDate, today);

  //     // set shared payload values
  //     payload.PaymentID = this.payment.PaymetnID;
  //     payload.TransactionID = this.payment.PaymentTransactionId;
  //     payload.PaymentProcessorID = this.payment.PaymentProcessorId;

  //     if (!this.refundFullAmount) {
  //       // only a portion of payment is being returned, so we will always execute a refund
  //       if (daysAgo <= 45) {
  //         payload.RefundMethod = 'refund';
  //       }
  //       else {
  //         // since payment is past 45 days, a check must be issued
  //       }
  //     }
  //     else
  //     {
  //       if (paymentDate === today) {
  //         payload.RefundMethod = 'void';
  //       }
  //       else if (paymentDate < today) {

  //         if (daysAgo <= 45) {
  //           // payment was not made today, but is within 45 days
  //           payload.RefundMethod = 'reversal';
  //         }
  //         else {
  //           // payment was made more than 45 days ago
  //           payload.RefundMethod = 'refund';
  //         }
  //       }
  //     }

  //     // set payload for use in refund click event
  //     this.triPosPaymentPayload = payload;
  //   }
  //   catch (err) {
  //     this.createMessage('Error getting refund method', 'Error');
  //   }
  // }

  // setTriPosPaymentPayload() {

  //   // perform void transaction if payment was made on current date
  //   // perform reversal transaction if payment within 45 days of current date
  //   // perform refund transaction if payment was made more than 45 days ago

  //   try {
  //     // initialize triPos transaction payload
  //     const payload = new TriPosCloudTransactionPayload();
  //     const today = new Date();
  //     const paymentDate = new Date(this.payment.PaymentTransactionDate);
  //     today.setHours(0, 0, 0, 0);
  //     paymentDate.setHours(0, 0, 0, 0);
  //     const daysAgo = this.datediff(paymentDate, today);

  //     // set shared payload values
  //     payload.PaymentID = this.payment.PaymetnID;
  //     payload.TransactionID = this.payment.PaymentTransactionId;
  //     payload.PaymentProcessorID = this.payment.PaymentProcessorId;

  //     // default method to check to start
  //     payload.RefundMethod = 'check';

  //     if (!this.refundFullAmount) {
  //       // only a portion of payment is being returned, so we will always execute a refund
  //       if (daysAgo <= 45) {
  //         payload.RefundMethod = 'refund';
  //       }
  //     }
  //     else
  //     {
  //       if (paymentDate.toISOString() === today.toISOString()) {
  //         payload.RefundMethod = 'void';
  //       }
  //       else if (paymentDate.toISOString() < today.toISOString()) {

  //         if (daysAgo <= 45) {
  //           // payment was not made today, but is within 45 days
  //           payload.RefundMethod = 'reversal';
  //         }
  //         else {
  //           // payment was made more than 45 days ago
  //           payload.RefundMethod = 'refund';
  //         }
  //       }
  //     }

  //     // set payload for use in refund click event
  //     this.triPosPaymentPayload = payload;
  //   }
  //   catch (err) {
  //     this.createMessage('Error getting refund method', 'Error');
  //   }
  // }

  // setRectangleHealthPaymentPayload() {

  //   // perform void transaction if payment was made on current date
  //   // perform reversal transaction if payment within 45 days of current date
  //   // perform refund transaction if payment was made more than 45 days ago

  //   try {
  //     // initialize triPos transaction payload
  //     const payload = new TriPosCloudTransactionPayload();
  //     const today = new Date();
  //     const paymentDate = new Date(this.payment.PaymentTransactionDate);
  //     today.setHours(0, 0, 0, 0);
  //     paymentDate.setHours(0, 0, 0, 0);
  //     const daysAgo = this.datediff(paymentDate, today);

  //     // set shared payload values
  //     payload.PaymentID = this.payment.PaymetnID;
  //     payload.TransactionID = this.payment.PaymentTransactionId;
  //     payload.PaymentProcessorID = this.payment.PaymentProcessorId;

  //     // default method to check to start
  //     payload.RefundMethod = 'check';

  //     if (!this.refundFullAmount) {
  //       // only a portion of payment is being returned, so we will always execute a refund
  //       if (daysAgo <= 45) {
  //         payload.RefundMethod = 'refund';
  //       }
  //     }
  //     else
  //     {
  //       if (paymentDate.toISOString() === today.toISOString()) {
  //         payload.RefundMethod = 'void';
  //       }
  //       else if (paymentDate.toISOString() < today.toISOString()) {

  //         if (daysAgo <= 45) {
  //           // payment was not made today, but is within 45 days
  //           payload.RefundMethod = 'reversal';
  //         }
  //         else {
  //           // payment was made more than 45 days ago
  //           payload.RefundMethod = 'refund';
  //         }
  //       }
  //     }

  //     // set payload for use in refund click event
  //     this.rectHealthPaymentPayload = payload;
  //   }
  //   catch (err) {
  //     this.createMessage('Error getting refund method', 'Error');
  //   }
  // }

  cancelClick() {
    this.dialogRef.close();
  }

  getPaymentProcessorDevicesByWorkstation(WorkstationID: string, LOCID: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentProcessorDevicesByWorkstation(WorkstationID, LOCID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  async onLoad() {
    this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    const locid = localStorage.getItem('LOCID');

    const promises: any[] = [
      this.getPayment(this.OriginalPaymentID),
      this.getPaymentRefundDistributions(this.OriginalPaymentID),
      this.getPaymentProcessors(),
      this.getPaymentProcessorDevicesByWorkstation(this.currentWorkStationID, locid),
      // this.getPaymentProcessorList(locid)
    ];

    try {
      // get payment record
      const results: any[] = await Promise.all(promises);
      this.payment = results[0];
      this.paymentDistributions = results[1];
      this.paymentProcessors = results[2];
      this.paymentDevices = results[3];
      this.isLoading = false;

      // set refund amount to payment amount
      this.refundAmount = this.payment.ApprovedPaymentAmount;
      this.refundAmountNotDistributed = this.refundAmount;
      this.setNewPaymentAmount();

      // set processor
      if (this.payment.PaymentProcessorId) {
        this.originalPaymentProcessorID = this.payment.PaymentProcessorId;
        this.paymentProcessors.forEach(a => {
          if (this.originalPaymentProcessorID === a.PaymentProcessorId) {
            this.refundMethod = a.Name;
            this.enumARProcessorID = a.enumARProcessorID;
          }
        });
      }
      else {
        this.refundMethod = 'Cash / Check';
      }
    }
    catch (err) {
      this.createMessage('Error retrieving payment record', 'Error');
    }
  }

  datediff(first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  getPayment(PaymentID: string) {
    return this.arService.getPayment(PaymentID).toPromise();
  }

  getPaymentProcessors() {
    return this.arService.getPaymentProcessors().toPromise();
  }

  getPaymentRefundDistributions(PaymentID: string) {
    return this.arService.getPaymentRefundDistributions(PaymentID).toPromise();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  returnPaymentType() {
    if (this.payment.enumARPayementTypeID === this.enumPaymentTypeCheck) {
      return this.payment.PaymentType;
    }
    else if (this.payment.enumARPayementTypeID === this.enumPaymentTypeCash) {
      return this.payment.PaymentType;
    }
    else {
      let payType = this.payment.PaymentType;
      if (this.payment.PaymentElectronicType) {
        payType += ' / ' + this.payment.PaymentElectronicType;
      }
      if (this.payment.PaymentCCType) {
        payType += ' / ' + this.payment.PaymentCCType;
      }
      return payType;
    }
  }

  refundFullAmountClicked() {
    if (!this.refundFullAmount) {

      // set refund amount to payment amount
      // this.refundAmount = this.payment.ApprovedPaymentAmount;
      this.saveCurrencyField('', 'refund', '', this.payment.ApprovedPaymentAmount);

      this.refundAmountNotDistributed = this.refundAmount;
      this.paymentAmountAfterRefund = this.refundAmount;

      // reset distribution refund amounts
      this.paymentDistributions.forEach(a => {
        a.RefundAmount = 0;
      });

      this.tdoTable.updateData(this.paymentDistributions);
    }
  }

  setNewPaymentAmount() {
    if (this.refundAmount < this.payment.ApprovedPaymentAmount) {
      this.paymentAmountAfterRefund = this.payment.ApprovedPaymentAmount - this.refundAmount;
    }
    else {
      this.paymentAmountAfterRefund = this.payment.ApprovedPaymentAmount;
    }
  }

  refundButtonDisabled() {
    if (this.refundFullAmount) {
      return false;
    }
    else {
      if (this.refundAmountNotDistributed === 0) {
        return false;
      }
      else {
        return true;
      }
    }
  }
}
